/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import React from 'react';
import { render } from 'react-dom';
import { InertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import Moment from 'react-moment';


const app = document.getElementById('app');

InertiaProgress.init({
    delay: 250,
    color: '#3c3a44',
    includeCSS: true,
    showSpinner: false,
});

render(
    <InertiaApp
        initialPage={JSON.parse(app.dataset.page)}
        /* eslint-disable */
        resolveComponent={ name => import(`./pages/${name}`).then(module => module.default) }
        /* eslint-enable */
    />,
    app
)
